import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';

import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import {getAuthToken, isPreview, updateToPreviewEndpoint} from './helpers/authHelper';
import './scss/app.scss';

axios.interceptors.request.use(request => {

  if(isHandlerEnabled(request)){
    let authToken = getAuthToken();
    if(request.url.indexOf("https://ingest.bidgely.com/itron") !== 0) {
      request.headers.Authorization = "Bearer " + authToken;
    }
  }
  if(isPreview()){
    request.url =  updateToPreviewEndpoint(request.url);
  }
  return request;
});

axios.interceptors.response.use((response) => {
  return response;
}, function (error) {
  return Promise.reject(error.response);
});

const isHandlerEnabled = (config={}) => {
  return config.hasOwnProperty('handlerEnabled') && !config.handlerEnabled ? false : true;
}
ReactDOM.render(
     <App />,
    document.getElementById('root')
   );
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
